
// 移动端youtube 下拉列表显示隐藏
function showYtPlayList() {
  if (window.innerWidth > 1024 || !document.getElementById('ytPlayListUl') || !document.getElementById('ytListBtnIcon')) {
    return
  }
  if (!document.getElementById('ytPlayListUl').style.display || document.getElementById('ytPlayListUl').style.display == 'none') {
    document.getElementById('ytPlayListUl').style.display = 'block';
    document.getElementById('ytListBtnIcon').className = 'fa fa-chevron-up'
  } else {
    document.getElementById('ytPlayListUl').style.display = 'none';
    document.getElementById('ytListBtnIcon').className = 'fa fa-chevron-down'
  }
}// Function to change the YouTube video - Video YouTube List
function changeVideo(videoId) {
  const videoPlayer = document.getElementById('playlistVideo');
  videoPlayer.src = `https://www.youtube.com/embed/${videoId}`;
}

// JavaScript code to handle image and play icon click events
function playVideo(element) {
  // Hide clicked image and play icon
  element.querySelector('.clickableImage').style.display = 'none';
  element.querySelector('.play-icon').style.display = 'none';

  // Show and play corresponding video
  let index = Array.from(document.querySelectorAll('.play-icon')).indexOf(element.querySelector('.play-icon'));
  let videoPlayer = document.getElementsByClassName('videoPlayer')[index];
  videoPlayer.style.display = 'block';
  videoPlayer.play();
}